import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthHook';
import { useTranslation } from 'react-i18next';

interface MetrikaConfig {
    defer?: boolean;
    clickmap?: boolean;
    trackLinks?: boolean;
    accurateTrackBounce?: boolean | number;
    webvisor?: boolean;
    ecommerce?: boolean | string;
}

const METRIKA_ID = 97901970;

const YandexMetrika: React.FC = () => {
    const location = useLocation();

    useEffect(() => {
        const config: MetrikaConfig = {
            defer: true,
            clickmap: false,
            trackLinks: true,
            accurateTrackBounce: true,
            webvisor: false,
        };

        const initMetrika = () => {
            (function (m: any, e: Document, t: string, r: string, i: 'ym') {
                m[i] =
                    m[i] ||
                    function (...args: unknown[]) {
                        (m[i].a = m[i].a || []).push(args);
                    };
                m[i].l = Date.now();

                const k = e.createElement(t) as HTMLScriptElement;
                const a = e.getElementsByTagName(t)[0];
                k.async = true;
                k.src = r;

                if (a && a.parentNode) {
                    a.parentNode.insertBefore(k, a);
                }
            })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

            window.ym(METRIKA_ID, 'init', config);
        };

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 2000);

        fetch('https://mc.yandex.ru/metrika/tag.js', {
            mode: 'no-cors',
            signal: controller.signal,
            priority: 'low',
        })
            .then(() => {
                clearTimeout(timeoutId);
                initMetrika();
            })
            .catch
            //TODO добавить запись в логи что метрика недоступна
            ();

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (typeof window.ym === 'function') {
            window.ym(METRIKA_ID, 'hit', location.pathname + location.search);
        }
    }, [location.pathname, location.search]);

    const { user } = useAuth();

    useEffect(() => {
        if (user?.ID && typeof window.ym === 'function') {
            window.ym(METRIKA_ID, 'userParams', {
                UserID: user.ID,
                UserName: user.Username,
            });
        }
    }, [user?.ID, user?.Username]);

    const { i18n } = useTranslation();

    useEffect(() => {
        if (typeof window.ym === 'function') {
            window.ym(METRIKA_ID, 'userParams', {
                Language: i18n.language,
            });
        }
    }, [i18n.language]);

    return null;
};

export default YandexMetrika;
